<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "PriceTier",
  data() {
    return {};
  },
  created() {},
};
</script>
